export * from './estimator';
export * from './revenueEstimate';
export * from './salesforce';

/**
 * Emit Google Tag Manager event when user begins or completes a step
 */
export const emitAnalytics = (
    eventName: string,
    data?: Record<string, unknown> | { estimate: 'available' | 'unavailable' },
): void => addTagManagerData(eventName, data);

/**
 * @see https://developers.google.com/tag-manager/devguide
 */
function addTagManagerData(event: string, data?: Record<string, unknown>) {
    if (window.dataLayer) window.dataLayer.push({ event, ...data });
}
